export default "__VITE_ASSET__Dxxu6sVn__"